export default __webpack_public_path__ + "static/media/horse.718db95b.svg";